import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useInitialValues = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const initialValues = useMemo(
    () => ({
      subject: undefined,
      body: `\n\n\n{company-logo}\nBest regards,\n${metaData.companyNameShort || ""} Team`
    }),
    [metaData]
  );

  return { initialValues };
};
